import React, { Fragment } from 'react';
import { Spinner } from 'react-bootstrap';

const Spin = ({
  isSpin,
  isModal,
}) => {
  return (
    <Fragment>
      <div className={`spinner-wrap ${isModal ? 'in-modal':''}`} hidden={!isSpin}>
        <Spinner animation='border' variant='success' role='status'/>
      </div>
    </Fragment>
  );
}

export default Spin;